import axios from "axios";

export default {
  state: {
    processingFeeCC: 0,
    processingFeeACH: 0,
  },
  mutations: {
    SET_PROCESSING_FEE_CC(state, quantity) {
      state.processingFeeCC = quantity;
    },
    SET_PROCESSING_FEE_ACH(state, quantity) {
      state.processingFeeACH = quantity;
    },
    
  },

  actions: {
    async updateProcessingFeeCC({ commit }, quantity) {
      try {
        const {data: response} = await axios.put("/api/settings/processing-fee/cc", {
          quantity: quantity,
        });

        commit("SET_PROCESSING_FEE_CC", response.data.value);

        return response;
      } catch (error) {
        throw error;
      }
    },

    async updateProcessingFeeACH({ commit }, quantity) {
      try {
        const {data: response} = await axios.put("/api/settings/processing-fee/ach", {
          quantity: quantity,
        });

        commit("SET_PROCESSING_FEE_ACH", response.data.value);

        return response;
      } catch (error) {
        throw error;
      }
    },
    
    async getProcessingFeeCC({ commit }) {
      try {
        const {data: response} = await axios.get("/api/settings/processing-fee/cc");

        commit("SET_PROCESSING_FEE_CC", response.data.value);

        return response;
      } catch (error) {
        throw error;
      }
    },

    async getProcessingFeeACH({ commit }) {
      try {
        const {data: response} = await axios.get("/api/settings/processing-fee/ach");

        commit("SET_PROCESSING_FEE_ACH", response.data.value);

        return response;
      } catch (error) {
        throw error;
      }
    }
  },

  getters: {
    getProcessingFeeCC: (state) => state.processingFeeCC,
    getProcessingFeeACH: (state) => state.processingFeeACH,
  },
}